<woa-modal-page-layout [showRefreshButton]="true" (onRefresh)="loadMemberSummary()"
                       [title]="'woa.heading.loyalty-cards.title'" [contentText]="contentText()">
    @if (showCards()) {
        <div class="cards">
            @for (ticket of tickets(); track ticket; let i = $index) {
                <woa-ticket class="cards-card" id="ticket-{{i}}"
                            [index]="i" [ticket]="ticket"></woa-ticket>
            }
            @for (card of loyaltyCards(); track card; let i = $index) {
                <woa-loyalty-card class="cards-card" id="loyalty-card-{{i}}"
                                  [index]="i" [card]="card" (onRedeem)="redeemCard(card)"></woa-loyalty-card>
            }
        </div>
    }
    <woa-link class="view-profile"
              [link]="'woa.button.loyalty-cards.viewProfile'"
              (onActivate)="profile()"></woa-link>
</woa-modal-page-layout>
